import { PagedLinjeQueryField } from "../interfaces/linje";
import { FmulinjeKursist } from "../interfaces/schema";
import { IColumn } from "../interfaces/table";
import { DeepRequiredNonNullable } from "../interfaces/ts-helpers";
import { UnwrapTypeKeysCap } from "../util/typeUtil";

export const defaultLinjeColumns: IColumn<PagedLinjeQueryField>[] = [
  { field: "nr", title: "Linjenr.", active: true, format: "number" },
  { field: "navn", title: "Navn", active: true, format: "string" },
  {
    field: "hotelNavigation.navn1",
    title: "Hotel",
    active: true,
    format: "string",
  },
  {
    field: "antalTilmeldte",
    title: "Antal deltagere",
    active: true,
    format: "number",
  },
];

export const defaultLinjeKursusholdColumns: IColumn<any>[] = [
  {
    field: "holdNr",
    title: "Kursusnr.",
    active: true,
    format: "number",
  },
  {
    field: "navn",
    title: "Kursusnavn",
    active: true,
    format: "string",
    link: (kursushold: any) => `/kursus/${kursushold.id}`,
  },
  {
    field: "fmukursusKategoriNavigation.navn",
    title: "Kategori",
    active: true,
    format: "number",
  },
  { field: "fraDato", title: "Startdato", active: true, format: "date" },
  {
    field: "fraKlDag",
    title: "Starttidspunkt",
    active: false,
    format: "duration",
  },
  { field: "tilDato", title: "Slutdato", active: true, format: "date" },
  {
    field: "tilKlDag",
    title: "Sluttidspunkt",
    active: false,
    format: "duration",
  },
];

export const defaultLinjeKursistColumns: IColumn<
  UnwrapTypeKeysCap<DeepRequiredNonNullable<FmulinjeKursist>, 4>
>[] = [
  {
    field: "person.kundeNr",
    title: "Kundenr.",
    active: true,
    format: "number",
    link: (fmulinjeKursist: any) => `/person/${fmulinjeKursist.personId}`,
  },
  {
    field: "person.personart",
    title: "Personart",
    active: false,
    format: "string",
  },
  {
    field: "person.fornavne",
    title: "Fornavne",
    active: true,
    format: "number",
  },
  {
    field: "person.efternavn",
    title: "Efternavn",
    active: true,
    format: "string",
  },
  {
    field: "deltagerStatusNavigation.navn",
    title: "Status",
    active: true,
    format: "string",
  },
  {
    field: "person.primaerPersonFirmaRelationPaa.firma.navn1",
    title: "Firmanavn",
    active: true,
    format: "string",
  },
  {
    field: "person.primaerPersonFirmaRelationPaa.emailArbejde",
    title: "E-mail arbejde",
    active: true,
    format: "string",
  },
  {
    field: "person.emailPrivat",
    title: "E-mail privat",
    active: false,
    format: "string",
  },
  {
    field: "person.adresse.adresse.adresselinie1",
    title: "Adresselinje 1",
    active: false,
    format: "string",
  },
  {
    field: "person.adresse.adresse.postnummer",
    title: "Postnr.",
    active: false,
    format: "string",
  },
  {
    field: "person.adresse.adresse.landNavigation.navn",
    title: "Land",
    active: false,
    format: "string",
  },
  {
    field: "overnatningstypeNavigation.navn",
    title: "Overnatning",
    active: true,
    format: "string",
  },
  { field: "id", title: "Id", active: false, format: "string" },
  {
    field: "opretDato",
    title: "Tilmeldingsdato",
    active: false,
    format: "date",
  },
  { field: "opretInit", title: "Oprettet af", active: false, format: "string" },
  { field: "retteDato", title: "Rettet", active: false, format: "date" },
  { field: "retteInit", title: "Rettet af", active: false, format: "string" },
];
